interface ArticleJsonLdProps {
  type: "article";
  headline: string;
  excerpt: string;
  author: string;
  publishedAt: string;
  updatedAt?: string;
  slug: string;
}

interface OrganizationJsonLdProps {
  type: "organization";
}

type JsonLdProps = ArticleJsonLdProps | OrganizationJsonLdProps;

const SITE_URL = "https://forexwiredaily.com";
const LOGO_URL = `${SITE_URL}/favicon.ico`;

const JsonLd = (props: JsonLdProps) => {
  let data: Record<string, unknown>;

  if (props.type === "article") {
    data = {
      "@context": "https://schema.org",
      "@type": "NewsArticle",
      headline: props.headline,
      description: props.excerpt,
      datePublished: props.publishedAt,
      dateModified: props.updatedAt || props.publishedAt,
      author: { "@type": "Person", name: props.author },
      publisher: {
        "@type": "Organization",
        name: "ForexWireDaily",
        logo: { "@type": "ImageObject", url: LOGO_URL },
      },
      mainEntityOfPage: `${SITE_URL}/news/${props.slug}`,
    };
  } else {
    data = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "ForexWireDaily",
      url: SITE_URL,
      logo: LOGO_URL,
      description:
        "The Pulse of Forex, Fintech & Prop Trading — breaking news, exposés, broker reviews, and regulatory intelligence.",
      sameAs: [
        "https://twitter.com/forexwiredaily",
        "https://linkedin.com/company/forexwiredaily",
      ],
    };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
};

export default JsonLd;
